import { Link } from 'react-router-dom'

const LandingHeader = () => {
  return (
    <header className="bg-white/95 backdrop-blur border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center">
            <img
              src="/images/Logo.svg"
              alt="Cirurgia Autorizada"
              className="h-9 w-auto sm:h-10"
            />
          </Link>

          <a
            href="#checklist-prontidao"
            className="text-sm font-medium text-teal-deep hover:text-teal transition-colors"
          >
            Fazer checklist
          </a>
        </div>
      </div>
    </header>
  )
}

export default LandingHeader
